import { combineReducers } from "redux";
import settingReducer from "./settingsSlice";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";
import sketchReducer from "./sketchSlice";
import stepReducer from "./stepSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  setting: settingReducer,
  authProvider: authSlice,
  sketch: sketchReducer,
  stepFlow: stepReducer,
});

export default rootReducer;
